/**
 * Module dependencies.
 */

import { ReactElement, useMemo } from 'react';
import { StepPageConfig } from 'src/types/advisor';
import { useAdvisor } from 'src/context/advisor/context';
import ContactFormStep from './contact-form';
import StepRadioOptions from './step-radio-options';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import uniq from 'lodash/uniq';

/**
 * `Props` type.
 */

type Props = StepPageConfig & {
  className?: string;
};

/**
 * `WaterCapacityRadioOptionsStep` component.
 */

const WaterCapacityRadioOptionsStep = (props: Props): ReactElement => {
  const { filteredModelRanges, isSuccessModelRanges } = useAdvisor();
  const waterCapacityValues = useMemo(() => {
    return orderBy(
      uniq(
        map(filteredModelRanges, ({ waterCapacity }) =>
          parseFloat(waterCapacity)
        )
      )
    );
  }, [filteredModelRanges]);

  if (isSuccessModelRanges && isEmpty(filteredModelRanges)) {
    return <ContactFormStep />;
  }

  return (
    <StepRadioOptions
      {...props}
      options={waterCapacityValues}
      translateOptions={false}
    />
  );
};

/**
 * Export `WaterCapacityRadioOptionsStep` component.
 */

export default WaterCapacityRadioOptionsStep;
